<template>
  <v-card
    class="pa-0 ma-0 pb-2 justify-center preview-container"
    flat
  >
    <v-card-title :class="[ 'pb-2', {'px-4': !$vuetify.breakpoint.xsOnly}]">
      <v-layout row wrap>
        <v-flex xs6>
          <div style="font-weight: 400 !important; font-size: 26px !important;">
            {{ $t('message.bizgainOnboarding.shareLink') }}
          </div>
        </v-flex>
        <v-flex xs6>
          <v-layout mb-2 justify-end>
            <v-icon class="cursor-pointer" @click="closeDialog">
              close
            </v-icon>
          </v-layout>
        </v-flex>
        <v-flex xs12 mb-3 style="border-bottom: solid 1px black;" />
        <v-flex xs12>
          <v-text-field
            ref="linkToCopy"
            :placeholder="$tc('message.bizgainOnboarding.summaryLink')"
            class="pt-0 mt-0"
            name="summaryLink"
            v-model="summaryLink"
            autocapitalize="off"
            data-vv-as="Summary Link"
          >
            <template v-slot:append>
              <div @click="copyLink()" class="ml-1 copyLink">
                <v-icon
                  color="primary"
                >
                  content_copy
                </v-icon>
              </div>
            </template>
          </v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-tabs
            :density="'compact'"
            :height="'40'"
            bg-color="info"
          >
            <v-tab class="cursor-pointer" @click="channel=OTPChannelTypes.WHATSAPP">
              <div>
                <img
                  :src="bizgainOnboardingImage.whatsapp"
                  class="whatsAppImageIcon"
                >
              </div>
              <span :class="['ml-1 label', {'activeTab': channel == OTPChannelTypes.WHATSAPP}, {'text-black': !(channel == OTPChannelTypes.WHATSAPP)}]">
                {{ $t('message.bizgainOnboarding.WhatsApp') }}
              </span>
            </v-tab>
            <v-tab class="cursor-pointer" @click="channel=OTPChannelTypes.EMAIL">
              <div>
                <img :src="bizgainOnboardingImage.gmail" class="imageIcon" style="margin-right: 2px !important;">
              </div>
              <span :class="['label ml-1', {'activeTab': channel == OTPChannelTypes.EMAIL}, {'text-black': !(channel == OTPChannelTypes.EMAIL)}]">
                {{ $t('message.bizgainOnboarding.Email') }}
              </span>
            </v-tab>
            <v-tab class="cursor-pointer" @click="channel=OTPChannelTypes.SMS">
              <div>
                <img :src="bizgainOnboardingImage.sms" class="imageIcon">
              </div>
              <span :class="['label ml-1', {'activeTab': channel == OTPChannelTypes.SMS}, {'text-black': !(channel == OTPChannelTypes.SMS)}]">
                {{ $t('message.bizgainOnboarding.Sms') }}
              </span>
            </v-tab>
          </v-tabs>
          <v-card
            :height="`${$vuetify.breakpoint.smAndDown ? '234px' : '220px'}`"
          >
            <v-card-text height="100%">
              <v-flex v-if="channel == OTPChannelTypes.WHATSAPP">
                <v-layout row wrap>
                  <v-flex xs12>
                    <span class="label">
                      {{ $t('message.bizgainOnboarding.MobileNumber') }}
                    </span>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <vue-tel-input
                      :for-summary="true"
                      :dropdown-options="getDropdownOptions()"
                      :input-options="getInputOptions()"
                      :invalid-msg="$t('message.bizgainOnboarding.mobileNumberValidationMessage')"
                      :value="phoneNumber"
                      :valid-characters-only="true"
                      :show-invalid-message="isShowInvalidMessage"
                      mode="national"
                      @on-input="phoneNumberTyped"
                      @validate="setPhoneObject"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <span class="label" style="padding-bottom: 0px !important:">
                      {{ $t('message.bizgainOnboarding.AgentName') }}
                    </span>
                    <v-text-field
                      class="mt-0 pt-0"
                      v-model="agentName"
                      :hint="$t('message.bizgainOnboarding.mobileNumberSecurityMessage')"
                      persistent-hint
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-if="channel == OTPChannelTypes.EMAIL">
                <v-layout row wrap>
                  <v-flex xs12>
                    <span class="label">
                      {{ $t('message.bizgainOnboarding.Email') }}
                    </span>
                  </v-flex>
                  <v-flex xs12 mb-2>
                    <v-text-field
                      placeholder="example@gmail.com"
                      v-model="email"
                      type="email"
                      class="pt-0 mt-0"
                      name="email"
                      autocapitalize="off"
                      autofocus
                      v-validate="'email|required'"
                      @focus="clearErrorByField($event, 'email')"
                      :error-messages="errors.first('email')? $tc('message.bizgainOnboarding.emailValidationMessage'):null"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <span class="label">
                      {{ $t('message.bizgainOnboarding.AgentName') }}
                    </span>
                    <v-text-field
                      class="mt-0 pt-0"
                      v-model="agentName"
                      :hint="$t('message.bizgainOnboarding.mobileNumberSecurityMessage')"
                      persistent-hint
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex v-if="channel == OTPChannelTypes.SMS">
                <v-layout row wrap>
                  <v-flex xs12>
                    <span class="label">
                      {{ $t('message.bizgainOnboarding.MobileNumber') }}
                    </span>
                  </v-flex>
                  <v-flex xs12 mb-4>
                    <vue-tel-input
                      :for-summary="true"
                      :dropdown-options="getDropdownOptions()"
                      :input-options="getInputOptions()"
                      :invalid-msg="$t('message.bizgainOnboarding.mobileNumberValidationMessage')"
                      :value="modelValue"
                      :valid-characters-only="true"
                      :show-invalid-message="showInvalidMessage"
                      mode="national"
                      @on-input="phoneNumberTyped"
                      @validate="setPhoneObject"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <span class="label" style="padding-bottom: 0px !important;">
                      {{ $t('message.bizgainOnboarding.AgentName') }}
                    </span>
                    <v-text-field
                      class="mt-0 pt-0"
                      v-model="agentName"
                      :hint="$t('message.bizgainOnboarding.mobileNumberSecurityMessage')"
                      persistent-hint
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-actions :class="[{'pl-3': $vuetify.breakpoint.xsOnly}]">
      <v-flex xs3 :class="{'ml-3':!$vuetify.breakpoint.xsOnly}">
        <v-layout :class="{ 'column reverse': $vuetify.breakpoint.xsOnly }">
          <v-flex :class="{ 'shrink mr-2': !$vuetify.breakpoint.xsOnly, 'xs12': $vuetify.breakpoint.xsOnly }">
            <v-btn
              depressed
              color="primary"
              :loading="sendingSummaryLink"
              :disabled="isSendBtnDisabled"
              @click="send()"
            >
              <span class="text-capitalize"> {{ $t('message.send') }}</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-actions>
  </v-card>
</template>
<script>
import Vue from 'vue';
import clearErrorByField from 'Mixins/clearErrorByField';
import { mapGetters } from 'vuex';
import { validatePhoneNumber } from 'Features/bizgainOnboarding/helpers/commonHelper';
import { Validator } from 'vee-validate';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
const { sendSummaryLink } = new ApiService();
import { objectiveType, OTPChannelTypes, bizgainOnboardingImage } from 'Features/bizgainOnboarding/constants'
import { VCard, VCardActions, VCardTitle, VCardText, VFlex, VLayout, VTabs, VTab, VBtn, VTextField, VIcon } from 'vuetify/lib';
export default {
  mixins: [clearErrorByField],
  components: {
    VCard,
    VCardActions,
    VCardText,
    VCardTitle,
    VFlex,
    VLayout,
    VTabs,
    VTab,
    VBtn,
    VTextField,
    VIcon
  },
  props: {
    summaryLink: {
      type: String,
      default: ''
    }
  },
  data (){
    return {
      channel: null,
      agentName: null,
      phoneNumber: null,
      objectiveType,
      OTPChannelTypes,
      modelValue: '',
      email: '',
      showInvalidMessage: false,
      phoneObject: {
        number: ''
      },
      objective: null,
      bizgainOnboardingImage,
      sendingSummaryLink: false
    }
  },
  created(){
    this.channel = this.OTPChannelTypes.WHATSAPP;
    if (this.businessDetails){
      if (this.businessDetails.businessPhoneNumber){
        this.modelValue = this.businessDetails.businessPhoneNumber;
      }
    }
    //this.showInvalidMessage = true;
    if (this.businessDetails.hasOwnProperty('creativeDetail')){
      if (this.businessDetails.creativeDetail.objective){
        switch (this.businessDetails.creativeDetail.objective) {
          case this.objectiveType.calls.id:
            this.objective = 'Get more calls'
            break
          case this.objectiveType.leadGeneration.id:
            this.objective = 'Get more leads'
            break
          case this.objectiveType.websiteVisits.id:
            this.objective = 'Get more wesite visits'
            break
          case this.objectiveType.instantMessages.id:
            this.objective = 'Get more messages'
            break
          default:
            break
        }
      }
    }
    Validator.extend('phoneNumber', {
      getMessage: field => 'The ' + field + ' value is invalid.',
      validate: value => { return validatePhoneNumber(value)  }
    });
  },
  computed: {
    ...mapGetters(['businessDetails', 'portalDomain', 'portalSupportNumber']),
    isSendBtnDisabled(){
      return !this.agentName || (!this.email && this.channel == this.OTPChannelTypes.EMAIL) || (!this.phoneObject && this.channel !== this.OTPChannelTypes.EMAIL);
    },
    isShowInvalidMessage(){
      return this.showInvalidMessage;
    }
  },
  methods: {
    copyLink(){
      let textToCopy = this.$refs.linkToCopy.$el.querySelector('input');
      textToCopy.select();
      document.execCommand('copy');
      Vue.notify({
        group: 'onboarding',
        type: 'success',
        text: 'Link Copied'
      });
    },
    getDropdownOptions() {
      return {
        disabled: false,
        showDialCodeInList: true,
        showDialCodeInSelection: true,
        showFlags: true,
        showSearchBox: true,
        tabindex: 0,
        width: '390px'
      };
    },
    getInputOptions() {
      return {
        autocomplete: 'on',
        autofocus: false,
        ariaDescribedby: '',
        id: '',
        maxlength: 25,
        name: 'telephone',
        showDialCode: false,
        placeholder: `Ex: ${this.portalSupportNumber}`,
        readonly: false,
        required: true,
        tabindex: 0,
        type: 'tel',
        styleClasses: '',
        verifiedNumber: this.businessDetails.phoneNumber
      }
    },
    phoneNumberTyped()
    {
      this.showInvalidMessage = false;
    },
    setPhoneObject(value)
    {
      this.phoneObject = value;
      this.phoneNumber = this.phoneObject.number;
    },
    getCurrentValidNumber(){
      return this.phoneObject && this.phoneObject.valid && this.phoneObject.number
    },
    async send(){
      let validNumber = this.getCurrentValidNumber();
      if(!validNumber){
        this.showInvalidMessage = true;
      }
      let channels = [];
      let isValid = await this.$validator.validate();
      if((isValid && validNumber) || this.channel == this.OTPChannelTypes.EMAIL){
        this.showInvalidMessage = false
        this.sendingSummaryLink = true;
        channels.push(this.channel);
        let sendSummaryLinkRequest = {
          sessionId: this.businessDetails.sessionId,
          portalDomain: this.portalDomain,
          agentName: this.agentName,
          businessName: this.businessDetails.name,
          objective: this.objective,
          phoneNumber: validNumber ? validNumber : '+919381158883',
          emailAddress: this.email,
          summaryUrl: this.summaryLink,
          summaryReviewImage: '',
          otpChannels: channels
        }
        try{
          if(this.channel == this.OTPChannelTypes.SMS || this.channel == this.OTPChannelTypes.WHATSAPP){
            if(this.getCurrentValidNumber()){
              await sendSummaryLink(sendSummaryLinkRequest);
            }
          }
          else if(this.channel == this.OTPChannelTypes.EMAIL) {
            await sendSummaryLink(sendSummaryLinkRequest);
          }
        }
        finally{
          this.sendingSummaryLink = false;
          this.closeDialog();
        }
      }
      else{
        this.showInvalidMessage = true;
      }
    },
    convertToBase64(value){
      let buff = new Buffer.from(value);
      let base64data = buff.toString('base64');
      return base64data;
    },
    closeDialog(){
      this.phoneObject = {
        number: ''
      };
      this.$emit('closeDialog');
    }
  }
}
</script>
<style scoped>
.cursor-pointer{
  cursor: pointer;
}
.copyLink{
  cursor: pointer;
}

.activeTab{
  color: #13ABB1;
}

.imageIcon{
  height: 22px;
  width: 22px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.whatsAppImageIcon{
  height: 26px;
  width: 26px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

::v-deep.v-tabs__item{
  padding-bottom: 0px !important;
}

::v-deep.v-text-field>.v-input__control>.v-input__slot:before{
  margin-bottom: 0px !important;
}
.v-text-field > .v-input__control > .v-input__slot {
  margin-bottom: 0px !important;
}
.text-black{
  color: black !important;
}
</style>
